<template>
  <div class="cookie-bar">
    <div class="cookie-bar__description">
      <p>
       {{ $t('cookieBar.text') }} <router-link :to="{ name: `${lang}.single-page`, params: { slug: 'privacy-policy' } }" class="underline_link">Privacy</router-link> {{ $t('common.and') }} <router-link :to="{ name: `${lang}.single-page`, params: { slug: 'cookie-policy' } }" class="underline_link">Cookie Policy</router-link>.
      </p>
    </div>

    <div 
      :class="{'cookie-bar__select--noTouch': !touch}"
      class="cookie-bar__select">
      <button @click="accept" class="cookie-bar__select--accept">{{ $t('notFound.allow') }}</button>
      <button @click="reject">{{ $t('notFound.notAllot') }}</button>
    </div>
  </div>
</template>

<script>
import { TweenMax, Power1 } from 'gsap/all'
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'
import { onAnalyticsReady } from 'vue-analytics'

export default {
  data: () => ({
    fadeTime: 0.5,
    emptyCookie: typeof Cookies.get('cookies-enabled') === 'undefined'
  }),
  computed: {
	  ...mapGetters([
      'lang',
      'touch'
    ])
  },
  async mounted () {
    await onAnalyticsReady()
    if (this.emptyCookie) return this.fadeIn()
    if (Cookies.get('cookies-enabled') === 'true') return this.accept()
  },
  methods: {
    accept () {
      this.$ga.enable()
      this.$ga.page(this.$router)
      this.$ga.event('gdpr', 'consent', 'accept')
      window.fbq('consent', 'grant')
      this.updateConsent(true)
    },
    reject () {
      this.$ga.disable()
      window.fbq('consent', 'revoke')
      this.updateConsent(false)
    },
    updateConsent (accepted) {
      Cookies.set('cookies-enabled', accepted, {
        expires: accepted ? 1825 : 7
      })
      this.emptyCookie = typeof Cookies.get('accepted-personal-data') === 'undefined'
      this.fadeOut()
    },
    fadeIn () {
      TweenMax.to(this.$el, this.fadeTime, {
        opacity: 1,
        autoAlpha: 1,
        ease: Power1.easeOut
      })
    },
    fadeOut () {
      TweenMax.to(this.$el, this.fadeTime, {
        opacity: 0,
        autoAlpha: 0,
        ease: Power1.easeOut,
        onComplete: this.$_enableGa
      })
    },
    $_enableGa () {
      this.$emit('cookiebar-closed')
    }
  }
}
</script>

<style lang="scss">
  @import "./cookie-bar.scss";
</style>